var map = {
	"./de.json": 9929,
	"./en.json": 790,
	"./esp.json": 7275,
	"./fr.json": 844,
	"./hi.json": 9493,
	"./pt.json": 9898,
	"./ru.json": 9672,
	"./se.json": 9546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2528;